import React, {useEffect, useState} from 'react'
import {useLoading, useCurrentUser} from 'usg-lib'
import LoginV2 from './pages/Version2/Login/LoginV2'
import AppPickerV2 from './pages/Version2/AppPicker/AppPicker'
import axios from "axios";
import {restUrls, googleOidcErrorKey, googleOidcErrorMessage} from "./utils/constants";
import {changeWhitelabelThemeV2} from "./utils/changeWhitelabelTheme";
import {usePostHog} from "posthog-js/react";

function App() {
  const resellerId = usg.data.resellerId // eslint-disable-line
  const ssoTokenAudience = usg.data.ssoTokenAudience ?? null // eslint-disable-line
  const redirectTo = usg.data.redirectTo ?? null // eslint-disable-line
  const [googleOidcError] = useState(() => {
    const params = new URLSearchParams(window.location.search)
    return params.get('error') === googleOidcErrorKey ? googleOidcErrorMessage : null
  })
  const [isLoadingReseller, setIsLoadingReseller] = useState(resellerId > 0)
  const [resellerLogo, setResellerLogo] = useState(null)
  const [supportEmail, setSupportEmail] = useState(null)
  const [isRedirecting, setIsRedirecting] = useState(false)
  const posthog = usePostHog()
  const {showLoading, hideLoading} = useLoading()
  const {currentUser, userIsLoggedIn, isLoading: isLoadingUser} = useCurrentUser()

  useEffect(() => {
    if (isLoadingUser || isLoadingReseller || isRedirecting) {
      showLoading()
    } else {
      hideLoading()
    }
  }, [isLoadingUser, isLoadingReseller, isRedirecting, showLoading, hideLoading])

  const loadReseller = async () => {
    if (!resellerId) {
      return;
    }

    setIsLoadingReseller(true)
    try {
      let response = await axios.get(`${restUrls.loadResellerWhitelabel}?resellerId=${resellerId}`)
      setIsLoadingReseller(false)
      setResellerLogo(response.data.logo)
      setSupportEmail(response.data.supportEmail)
      changeWhitelabelThemeV2(response.data.colors)
    } catch (error) {}
    setIsLoadingReseller(false)
  }

  useEffect(() => {
    setResellerLogo(null)
    loadReseller()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resellerId])

  useEffect(() => {
    if (!currentUser) {
      return;
    }

    posthog?.identify(
      currentUser.id,
      {
        email: currentUser.email,
        name: currentUser.name,
        division: currentUser.division,
        level: currentUser.level,
        department: currentUser.department,
      },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser])

  useEffect(() => {
    if (currentUser && ssoTokenAudience && userIsLoggedIn) {
      setIsRedirecting(true)
      let uri = '/sso/redirect?audience='+ssoTokenAudience
      if (redirectTo) {
        uri += '&'+redirectTo
      }
      window.location.href = uri
    }
  }, [ssoTokenAudience, currentUser, redirectTo, userIsLoggedIn]);

  return (
    <>
      {!isLoadingUser && (
        userIsLoggedIn ? (
          // With an audience the redirect effect above already owns this render: showing the
          // picker would race it and drop the destination the visitor came in with.
          ssoTokenAudience ? null : <AppPickerV2 logo={resellerLogo}/>
        ) : (
          <LoginV2 logo={resellerLogo} supportEmail={supportEmail} errorMessage={googleOidcError}/>
        )
      )}
    </>
  );
}

export default App;
